<ion-row [ngClass]="rowData.rowClass">
<ng-container *ngFor="let column of rowData.columns;let i = index">
  <ion-col size="4"  *ngIf="subRows && i===0; else simple" (click)="toggleExpand(row)" [ngClass]="column.columnClass">
    <ion-icon name="caret-{{expanded ? 'down' : 'forward'}}-outline"></ion-icon>
    {{ column.value }}
  </ion-col>  
  <ng-template #simple> 
    <ion-col size="4" [ngClass]="column.columnClass">
      {{ column.value }}
    </ion-col>
  </ng-template>
</ng-container>
</ion-row>


<ng-container *ngIf="expanded">
  <ion-row *ngFor="let subRow of subRows" [ngClass]="subRow.rowClass">
    <ion-col size="4"  *ngFor="let column of subRow.columns" [ngClass]="column.columnClass">
      {{ column.value }} 
    </ion-col>
  </ion-row>
</ng-container>
